import { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';

export function MultiplayerMenu(props: {
  host: () => void;
  join: (id: string) => void;
  joining: boolean;
}) {
  const {
    host, join,
  } = props;

  const [roomIdInput, setRoomIdInput] = useState('');

  return (
    <Card className="max-w-md w-full min-h-[300px]">
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl font-bold text-center">Welcome to Card Engine</CardTitle>
        <CardDescription className="text-center">Sign in to your account to continue</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-1 items-center">
        <div className='flex flex-col gap-8 w-full'>
          <Button className='w-full' onClick={host} disabled={props.joining}>
            Host A Room
          </Button>

          <div className='text-center'>
            <span className='font-medium text-lg'>OR</span>
          </div>

          <div className="flex w-full max-w-sm items-center space-x-2">
            <Input type="text" placeholder="Room Code" onChange={(event) => setRoomIdInput(event.target.value)} value={roomIdInput} />
            <Button type="submit" onClick={() => join(roomIdInput)} disabled={props.joining}>Join</Button>
          </div>
        </div>

      </CardContent>
      <CardFooter className="flex flex-col">

      </CardFooter>
    </Card>
  );
}
